import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import { AppNotification } from "../../models/notification/notification";

export const useSelectNotificationsForTransportOrder = (
    orderId: string
): AppNotification[] => {
    const allNotifications = useAppSelector(
        (state): any[] => state.notification.notifications
    );

    const notifications = useMemo(
        (): AppNotification[] => allNotifications.filter((n) => n.transportOrderId === orderId),
        [allNotifications, orderId]
    );

    return notifications;
};
